<div class="viz-color-config-modal">
  <ng-template #modalHeaderContent>
    <mode-dialog-header>
      <h1 heading>{{ isFieldLevel ? 'Default color settings' : 'Color settings' }}</h1>
    </mode-dialog-header>
  </ng-template>

  <div *ngIf="!isChildModal" class="color-modal-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <ng-container *ngTemplateOutlet="modalHeaderContent"></ng-container>
  </div>

  <div *ngIf="isChildModal" class="color-modal-header child-modal">
    <ng-container *ngTemplateOutlet="modalHeaderContent"></ng-container>
  </div>

  <mode-color-confirmation-dialog
    *ngIf="shouldShowConfirmationDialog"
    [currentField]="dialogField"
    (confirmDialogActionClick)="onConfirmDialogActionClick($event.field, $event.discardChanges)"
  ></mode-color-confirmation-dialog>

  <mode-loader
    *ngIf="!hasLoadError && (isLoading$ | async)"
    class="loader"
    [class.visible]="showLoader$ | async"
    [class.discrete]="isDiscreteField"
    [class.continuous]="isContinuousField"
    [class.continuous-range]="isContinuousField && !hideRangeControls"
    [class.field-level]="isFieldLevel"
    type="secondaryGreen"
  ></mode-loader>

  <div class="color-modal-body" *ngIf="!hasLoadError && (isLoading$ | async) === false">
    <div *ngIf="isFieldLevel" class="field-level-info">
      Set default colors for fields in this dataset; these colors will apply only to fields in the color channel.
      Chart-level formatting overrides these defaults.
    </div>
    <mode-background-settings-toggle
      [showTextSettings]="isText"
      [enableTextSettings]="canUseAsBackground"
      [isUseAsBackground]="isUseAsBackground"
      (markTargetUpdated)="onMarkTargetClick($event)"
    ></mode-background-settings-toggle>

    <mode-field-and-palette-selector
      [view]="view"
      [activeColorPalette]="selectedColorPalette"
      [allColorPalettes]="isContinuousField ? continuousPalettes : discretePalettes"
      [currentField]="currentField"
      [allFields]="allColorFieldsInEncoding"
      (paletteChanged)="onPaletteChange($event)"
      (fieldChanged)="onFieldChange($event)"
    ></mode-field-and-palette-selector>

    <mode-sequential-divergent-color-picker
      *ngIf="isContinuousField"
      [selectedColorPalette]="selectedColorPalette"
      [flyoutDefaultPalette]="baseColorPalette"
      [allColorPalettes]="orgPalettes"
      [labels]="gradientValueLabels"
      [vizToken]="vizToken"
      [hideSteps]="hideSteps"
      [hideLabels]="hideStepLabels"
      [hideAutoLabel]="!hideStepLabels && hideSteps"
      [numberOfSteps]="numberOfSteps"
      [isBinned]="currentField.isBinned ?? false"
      (colorChanged)="onContinuousColorChange($event)"
      (stepChanged)="onStepChange($event.palette, $event.numberOfSteps)"
    ></mode-sequential-divergent-color-picker>

    <mode-range-inputs
      *ngIf="isContinuousField && !hideRangeControls"
      [domainMin]="colorDomain[0]"
      [domainMax]="colorDomain[1]"
      [minValue]="userGradientValues?.min"
      [midpointValue]="userGradientValues?.mid"
      [maxValue]="userGradientValues?.max"
      [gradientType]="gradientType"
      [isDate]="currentField.isFormulaDate ?? false"
      [isBinned]="currentField.isBinned ?? false"
      (rangeUpdated)="onContinuousRangeUpdated($event)"
      (isValid)="onRangeIsValidChange($event)"
    ></mode-range-inputs>

    <mode-color-values
      *ngIf="isDiscreteField"
      [selectedColorPalette]="baseColorPalette"
      [allColorPalettes]="orgPalettes"
      [listOfItems]="listOfItems"
      [vizToken]="vizToken"
      (colorChanged)="onDiscreteColorChange($event)"
      (unassignColors)="onBulkUnassign($event)"
    ></mode-color-values>
    <div class="unassigned-color" *ngIf="isDiscreteField">
      <mode-unassigned-color-picker
        [color]="unassignedColor"
        [allColorPalettes]="orgPalettes"
        [vizToken]="vizToken"
        [selectedColorPalette]="baseColorPalette"
        (colorSelected)="onUnassignedColorSelected($event)"
      ></mode-unassigned-color-picker>
    </div>
    <div class="unassigned-values-warning" *ngIf="hasHighCardinalityWithUnassigned">
      <div>
        Some values were not assigned a color due to the number of unique values. By default, unassigned values will
        display with a neutral color.
      </div>
    </div>
  </div>
  <div class="load-error" *ngIf="hasLoadError">
    <capra-icon icon="icon-warning"></capra-icon>
    <div [innerHTML]="errorDescription"></div>
  </div>
  <div class="action-buttons">
    <div class="left-actions">
      <capra-button
        *ngIf="!isChildModal"
        data-test="colors-modal-cancel-button"
        text="Cancel"
        variant="secondary"
        color="neutral"
        (clicked)="cancel()"
      ></capra-button>
      <capra-button
        data-test="colors-modal-reset-button"
        text="Reset"
        variant="secondary"
        color="neutral"
        (clicked)="reset()"
        [disabled]="!hasChanges || hasLoadError || (isLoading$ | async)"
      ></capra-button>
    </div>
    <div class="right-actions">
      <capra-button
        *ngIf="!isChildModal"
        data-test="colors-modal-apply-button"
        text="Apply"
        variant="secondary"
        color="neutral"
        (clicked)="apply(false)"
        [disabled]="!hasChanges || hasLoadError || (isLoading$ | async) || hasInputError"
      ></capra-button>
      <capra-button
        data-test="colors-modal-apply-and-close-button"
        [text]="isChildModal ? 'Apply' : 'Apply & close'"
        color="default"
        (clicked)="apply(true)"
        [disabled]="hasLoadError || (isLoading$ | async) || hasInputError"
      ></capra-button>
    </div>
  </div>
</div>
